module.exports = __webpack_public_path__ + "img/participants-savings-gran.1340a489.png";